module.exports = __webpack_public_path__ + "img/1503354544.cab568ce.jpg";